<template>
  <div>
    <div class="relative">
      <div
        ref="carousel"
        :class="{
          'keen-slider': isSlider && $children.length > 1,
          [carouselClass]: !isSlider
        }"
      >
        <slot></slot>
      </div>
      <button
        v-if="isSlider && $children.length > 1"
        class="slide-button prev"
        @click="prev"
        :disabled="active === 0"
      >
        &lt;
      </button>
      <button
        v-if="isSlider && $children.length > 1"
        class="slide-button next"
        @click="next"
        :disabled="active + 1 === numSlides"
      >
        &gt;
      </button>
    </div>
    <div
      v-if="isSlider && $children.length > 1"
      class="py-4 flex justify-center"
    >
      <button
        class="p-2 flex justify-center items-center"
        v-for="index in numSlides"
        :key="index"
        @click="moveToSlide(index - 1)"
      >
        <span
          class="w-3 h-3 rounded-full"
          :class="{
            'bg-blue': index - 1 === active,
            'bg-gray-dark': index - 1 !== active
          }"
        ></span>
      </button>
    </div>
  </div>
</template>

<script>
import KeenSlider from 'keen-slider';

export default {
  props: {
    mobileOnly: {
      type: Boolean,
      defaul: false
    },
    carouselClass: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      carousel: null,
      active: 0,
      numSlides: 0,
      width: window.innerWidth
    };
  },

  computed: {
    isSlider() {
      return this.mobileOnly ? this.width < 1154 : true;
    }
  },

  watch: {
    $children: function() {
      this.handleResize();
    }
  },

  methods: {
    next() {
      this.carousel.next();
    },
    prev() {
      this.carousel.prev();
    },
    moveToSlide(index) {
      this.carousel.moveToSlide(index);
    },
    handleSlideChanged(e) {
      const details = e.details();
      this.active = details.absoluteSlide;
      this.numSlides = details.size;
    },
    handleResize() {
      this.width = window.innerWidth;

      if (this.isSlider && this.$children.length > 1) {
        this.create();
      } else {
        this.destroy();
      }
    },
    create() {
      if (this.carousel !== null) {
        return;
      }

      this.carousel = new KeenSlider(this.$refs.carousel, {
        slideChanged: this.handleSlideChanged
      });
    },
    destroy() {
      if (this.carousel !== null) {
        this.carousel.destroy();

        this.$children.forEach(child => {
          child.$el.attributeStyleMap.clear();
        });

        this.carousel = null;
      }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  mounted() {
    this.$nextTick(() => {
      this.handleResize();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);

    this.destroy();
  }
};
</script>

<style lang="scss">
@import '~keen-slider/keen-slider.min.css';

.slide-button {
  @apply absolute h-12 w-12 text-blue text-2xl;

  top: calc(50% - 1.5rem);

  @screen lg {
    @apply bg-white;
  }

  &:disabled {
    @apply opacity-50 cursor-not-allowed pointer-events-none;
  }

  &.prev {
    left: -1.5rem;
  }

  &.next {
    right: -1.5rem;
  }

  @screen lg {
    &.prev {
      left: 2rem;
    }

    &.next {
      right: 2rem;
    }
  }
}
</style>
